import { AfterViewInit, Component, ElementRef, forwardRef, Input, NgZone, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { GoogleMapsService } from '../../services/google.maps.service';

@Component({
  selector: 'ig-address-input',
  templateUrl: './address.input.component.html',
  styleUrls: ['./address.input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AddressInputComponent),
      multi: true,
    },
  ],
})
export class AddressInputComponent implements ControlValueAccessor, AfterViewInit {
  private _value: {
    lat: number;
    lng: number;
    address: string;
  };
  private _notifyChange: any;
  public locationFormGroup: FormGroup;

  @Input() public disabled: boolean;
  @Input() public label: string;
  @Input() public label2: string;
  @Input() public isRequired = false;
  @ViewChild('inputElement') public inputElement: any;
  public addressValue: string;

  public get value() {
    return this._value;
  }

  public set value(newValue: any) {
    this._value = newValue;
    this._notifyChange(this._value);
  }

  constructor(private googleMapService: GoogleMapsService, private zone: NgZone, private formBuilder: FormBuilder) {
    this.locationFormGroup = this.formBuilder.group({
      address: [null, [Validators.required]],
    });
  }

  public writeValue(obj: { lat: number; lng: number; address: string }): void {
    this._value = obj;
    this.addressValue = !!this._value ? this._value.address : null;
  }

  public registerOnChange(fn: any): void {
    this._notifyChange = fn;
  }

  public registerOnTouched(fn: any): void {}

  public ngAfterViewInit() {
    this.googleMapService.getGoogle().then(() => {
      let autoComplete = new google.maps.places.Autocomplete(this.inputElement.input.nativeElement);
      autoComplete.addListener('place_changed', () => {
        this.zone.run(() => {
          let place = autoComplete.getPlace();

          if (place.geometry) {
            console.log('address input', place);
            let stateAbbr = '',
              cityName = '',
              country = '';
            if (place.address_components) {
              place.address_components.forEach((x) => {
                if (x.types.any((y) => y === 'administrative_area_level_1')) {
                  stateAbbr = x.short_name;
                }
                if (x.types.any((y) => y === 'locality')) {
                  cityName = x.long_name;
                }
                if (x.types.any((y) => y === 'country')) {
                  country = x.long_name;
                }
              });
            }
            this.value = {
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng(),
              address: place.formatted_address,
              address_components: place.address_components,
              placeId: place.place_id,
              cityName,
              stateAbbr,
              country,
            };
          } else {
            this.value = {
              address: place.name,
            };
          }
        });
      });
    });
  }

  public clear() {
    this.addressValue = null;
    this.value = null;
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/address.input/address.input.component.ts